import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const PageHeader = ({ title, subtitle }) => {
  return (
    <HeaderContainer>
      <Title
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {title}
      </Title>
      
      {subtitle && (
        <Subtitle
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {subtitle}
        </Subtitle>
      )}
      
      <Divider 
        initial={{ width: 0 }}
        animate={{ width: '80px' }}
        transition={{ duration: 0.8, delay: 0.4 }}
      />
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Title = styled(motion.h1)`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--text-color);
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled(motion.p)`
  font-size: 1.1rem;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto 1.5rem;
  line-height: 1.6;
`;

const Divider = styled(motion.div)`
  height: 4px;
  background-color: var(--primary-color);
  margin: 0 auto;
  border-radius: 2px;
`;

export default PageHeader;